// node_modules
import { FC, useState } from "react";
// Types
import { TPassSideNotePost } from "Types";
// Components
import { CreateSideNoteReply } from "./CreateSideNoteReply";
// styles
import styles from "./createSideNote.module.scss";

export type TCreateSideNoteProps = {
    sideNoteInfo: TPassSideNotePost,
    hasNoComments?: boolean,
}

export const CreateSideNote: FC<TCreateSideNoteProps> = ({sideNoteInfo, hasNoComments} : TCreateSideNoteProps) => {
    // State
    const [isCurrentlyEditing, setIsCurrentlyEditing] = useState(false);

    // Logic
    const stopEditing = () => { 
        // hide side note creation form
        setIsCurrentlyEditing(false); 
    };

    const createSideNoteDone = () => {
        // hide side note creation form
        setIsCurrentlyEditing(false);
    }

    // Render
    if(isCurrentlyEditing || hasNoComments) {
        return (
            <CreateSideNoteReply hasNoComments={hasNoComments} sideNoteInfo={sideNoteInfo} onCancel={stopEditing} onDone={createSideNoteDone} />
        );
    } else {
        return (
            <button id="post-comment-button" className={styles.addNewButton} onClick={() => { setIsCurrentlyEditing(true); }}>+ Add a new comment</button>
        );
    }
};